import "./AdminSection.scss";




function AdminSection() {
    return <div className="AdminSection">
        <p className="AdminSection__title">ADMIN</p>
        <div className="AdminSection__InfoContainer">
            <div className="InformationContainer">
                <label>Total Storage Analysis</label>
                <table >
                    <tbody>
                        <tr>
                            <td >Total Users</td>
                            <td>13362</td>
                        </tr>
                        <tr>
                            <td >Total Data Size</td>
                            <td>2.43 TB</td>
                        </tr>
                        <tr>
                            <td >Total Objects</td>
                            <td>3757938</td>
                        </tr>
                        <tr>
                            <td >Total Large Storage Users</td>
                            <td>157</td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div className="InformationContainer">
                <label>Free Users Storage Analysis</label>
                <table >
                    <tbody>
                        <tr>
                            <td >Free Users Count</td>
                            <td>13273</td>
                        </tr>
                        <tr>
                            <td >Free Users Total Data</td>
                            <td>2.01 TB</td>
                        </tr>
                        <tr>
                            <td >Free Users Total Objects</td>
                            <td>3288858</td>
                        </tr>
                        <tr>
                            <td >Free Large Storage Users</td>
                            <td>124</td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div className="InformationContainer">
                <label>Annual Paid Users Analysis</label>
                <table >
                    <tbody>
                        <tr>
                            <td >Annual Users Count</td>
                            <td>28</td>
                        </tr>
                        <tr>
                            <td >Annual Users Total Data</td>
                            <td>345.03 GB</td>
                        </tr>
                        <tr>
                            <td >Annual Users Total Objects</td>
                            <td>422126</td>
                        </tr>
                        <tr>
                            <td >Annual Large Storage Users</td>
                            <td>15</td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div className="InformationContainer">
                <label>Lifetime Paid Users Analysis</label>
                <table >
                    <tbody>
                        <tr>
                            <td >Lifetime Users Count</td>
                            <td>61</td>
                        </tr>
                        <tr>
                            <td >Lifetime Users Total Data</td>
                            <td>84.91 GB</td>
                        </tr>
                        <tr>
                            <td >Lifetime Users Total Objects</td>
                            <td>46954</td>
                        </tr>
                        <tr>
                            <td >Lifetime Large Storage Users</td>
                            <td>18</td>
                        </tr>
                    </tbody>
                </table>

            </div>

        </div>

        <div className="AdminSection__UnpaidUsersList">
            <label>Unpaid Users List</label>
            <div className="TableBox">
                <table>
                    <thead>
                        <tr className="tableHead">
                            <th>User Email</th>
                            <th>Public Address</th>
                            <th>Account Type</th>
                            <th>Created At</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr >
                            <td>{'sss'}</td>
                            <td>{'sss'}</td>
                            <td>{'sss'}</td>
                            <td>{'sss'}</td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>
        </div>

    </div>
}

export default AdminSection;
